import { type ReactNode } from 'react';
import { FieldInput, FieldSelect } from '@/components/ui/field-input';
import { PasswordRequirements } from '@/components/ui/password-requirements';
import { SectionHeader } from '@/components/ui/section-header';
import { passwordRulesPass } from '@/utils/password-rules';
import type { UserRole } from '@/types/auth';
import { fieldChange } from '../utils/field-change';
import { PasswordGeneratorRow } from './password-generator-row';
import type { RowProps } from './new-member-rows';

const ROLES: { value: UserRole; label: string }[] = [
  { value: 'collector', label: 'Collector' },
  { value: 'approacher', label: 'Approacher' },
  { value: 'mago', label: 'Mago' },
  { value: 'admin', label: 'Admin' },
];

function PasswordInputs({ data, onChange, errors }: RowProps): ReactNode {
  const submitted = !!(errors.password || errors.password_confirm);
  const invalid =
    submitted && !passwordRulesPass(data.password, data.password_confirm);
  return (
    <>
      <FieldInput
        type="password"
        placeholder="Contraseña"
        value={data.password}
        onChange={fieldChange(data, onChange, 'password')}
        invalid={invalid}
        error={errors.password}
      />
      <FieldInput
        type="password"
        placeholder="Repetir contraseña"
        value={data.password_confirm}
        onChange={fieldChange(data, onChange, 'password_confirm')}
        invalid={invalid}
        error={errors.password_confirm}
      />
    </>
  );
}

function RoleSelect(p: RowProps): ReactNode {
  return (
    <FieldSelect
      value={p.data.role}
      onChange={fieldChange(p.data, p.onChange, 'role')}
      error={p.errors.role}
    >
      {ROLES.map((r) => (
        <option key={r.value} value={r.value}>
          {r.label}
        </option>
      ))}
    </FieldSelect>
  );
}

export function AccountSection(p: RowProps): ReactNode {
  const handleGenerate = (pw: string): void => {
    p.onChange({ ...p.data, password: pw, password_confirm: pw });
  };
  const panelVisible = !!p.data.password || !!p.data.password_confirm;
  return (
    <div className="space-y-sm">
      <SectionHeader label="Cuenta" />
      <RoleSelect {...p} />
      <PasswordInputs {...p} />
      <PasswordRequirements
        password={p.data.password}
        confirm={p.data.password_confirm}
        visible={panelVisible}
      />
      <PasswordGeneratorRow
        onGenerate={handleGenerate}
        current={p.data.password}
      />
    </div>
  );
}
